import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Store } from "@ngrx/store";
import { AppState } from "../store/state/app.state";

@Injectable({
  providedIn: "root",
})
export class ResearchGridDataService {
  apiEP: string = window.apiUrl;
  legacyUrl: string = window.caUrl;
  constructor(
    private http: HttpClient,
    private store: Store<AppState>,
  ) {}

  getResearchBaseUrl(ticker: string): Observable<any> {
    return this.http.get(
      `${this.apiEP}/api/researchapiengine_link_from_env?ticker=${ticker}`,
    );
  }
  getDocumentsCall(json): Observable<any> {
    const jsonData = {
      company_id: json.companyId,
      page: json.page,
      page_size: json.pageSize,
      primary_co: json.primaryCo,
      research_analyst_id: json.analystId,
      publisher_ids: json.publisherIds,
      sort_by: json.sortBy,
      sort_order: json.sortOrder,
    };
    if (json.date) {
      jsonData["start_date"] = json.date.startDate;
      jsonData["end_date"] = json.date.endDate;
    }
    return this.http.post(`${this.apiEP}/resapi/v2/get_documents`, jsonData);
  }

  getBulkDownload(json): Observable<any> {
    const jsonData = {
      company_id: json.companyId,
      document_details: json.documentDetails,
    };
    return this.http.post(` ${this.apiEP}/api/generateresearchzip`, jsonData);
  }
  getAnalystList(companyId): Observable<any> {
    const jsonData = {
      company_id: companyId,
    };
    return this.http.post(
      `${this.apiEP}/resapi/get_analysts_by_symbol`,
      jsonData,
    );
  }
  getBrokerList(companyId): Observable<any> {
    const jsonData = {
      company_id: companyId,
    };
    return this.http.post(
      `${this.apiEP}/resapi/get_brokers_by_symbol`,
      jsonData,
    );
  }

  getPrintDocumentURL(documentId: number): Observable<any> {
    const jsonData = {
      document_id: [documentId],
    };

    return this.http.post(`${this.apiEP}/resapi/get_doc_by_user_jwt`, jsonData);
  }

  getDownloadDocumentURL(
    documentId: number,
    companyId: number,
    fileName: string,
    enableWatermark = 0,
  ): string {
    return `${this.apiEP}/api/downloadsingleresearchdoc?document_id=${documentId}&company_id=${companyId}&file_name=${fileName}&enable_watermark=${enableWatermark}`;
  }
}
